<template>
  <div :class="classList">
    <slot name="label">
      <label v-if="label" :for="id">{{ label }}</label>
    </slot>
    <slot>default slot</slot>
    <span
      v-for="error in validationErrors"
      :key="error.key"
      class="form-group-error-wrapper"
    >
      <span
        :id="error.id ? error.id + '-error' : id + '-error'"
        role="alert"
        aria-live="polite"
        aria-atomic="true"
        class="form-group-error"
        v-show="
          validation.$error && usingCompositionApi
            ? validation[error.key].$invalid
            : !validation[error.key]
        "
      >
        <component
          :is="icon"
          inline
          name="varning"
          class="warning"
          :alt="isStoryBook ? 'Error buy ticket alt text' : iconErrorAltText"
        />
        {{ error.message }}
      </span>
    </span>
  </div>
</template>

<script>
import StIcon from "../icon/Icon.vue";
import StIconLegacy from "../icon/IconLegacy.vue";
import { version } from "vue";

export default {
  name: "st-form-group",
  components: {
    StIcon,
    StIconLegacy,
  },
  props: {
    id: {
      type: String,
    },
    label: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    validation: {
      type: Object,
    },
    validationErrors: {
      type: Array,
      default: () => {
        return [];
      },
    },
    iconErrorAltText: {
      type: String,
    },
    usingCompositionApi: {
      type: Boolean,
    },
  },
  computed: {
    isStoryBook() {
      return process.env.STORYBOOK_SELF;
    },
    classList: function() {
      return [
        "st-form-group",
        this.required && "required",
        this.hasError && "invalid",
      ];
    },
    hasError() {
      if (!this.validation) return false;

      return this.validation.$error;
    },
    icon() {
      return version && parseInt(version) === 3 ? "StIcon" : "StIconLegacy";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/main.scss";

.st-form-group {
  margin-top: 1em;

  &.required {
    label:after {
      content: " - obligatoriskt";
      font-style: italic;
      font-weight: 400;
    }
  }

  label {
    height: 1.2375em;
    font-size: 0.875em;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    font-family: $source-sans-pro;
    color: $dark-grey;
    line-height: 1.4;
    letter-spacing: normal;
    display: inline-block;
    margin-bottom: 0.3125em;
    text-align: left;
  }

  .form-group-error-wrapper {
    font-size: 1em;
  }

  .form-group-error {
    display: none;
    font-size: 0.875em;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    font-family: $source-sans-pro;
    letter-spacing: normal;
    text-align: left;
    margin-top: 0.25em;
  }

  &.invalid .form-group-error {
    display: block;
    color: $invalid;
  }

  .warning {
    background-size: 0.875em 0.875em;
    display: inline-block;
    margin-right: 0.375em;
    line-height: 0;
    &.st-icon.md {
      width: 0.875em;
      height: 0.875em;
    }
  }
}
</style>
